// extracted by mini-css-extract-plugin
module.exports = {"addressSection":"PropertyIntroduction_addressSection__Ww56t","propertyIdText":"PropertyIntroduction_propertyIdText__6_Dtj","tags":"PropertyIntroduction_tags__2yCSS"};